@use "../../sass/global/global" as *;

:host {
    display: inline-block;
    position: relative;
    box-sizing: border-box;

    * {
        box-sizing: border-box;

        @media (prefers-reduced-motion: reduce) {
            transition: none !important;
        }
    }
}

.button {
    @include font(bold);
    display: inline-block;
    color: #fff;
    text-decoration: none;
    font-size: 13px;
    line-height: 16px;
    text-transform: uppercase;
    border: 1px solid #fff;
    padding: 13px 30px;
    height: 44px;
    transition: all 300ms ease-in-out;

    :host(.is-mobile) & {
        width: 100%;
        text-align: left;
        position: relative;

        ux-icon {
            position: absolute;
            right: 30px;
            top: 50%;
            transform: translateY(-50%);
        }
    }

    &:hover {
        background-color: #fff;
        color: #000;
    }

    ux-icon {
        margin-left: 5px;
        font-size: 17px;
    }
}

.tile-content {
    position: relative;
    display: flex;
    flex-direction: column;
}

.media-container {
    line-height: 0;
    min-width: 160px;
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    position: relative;
}

video,
img {
    position: absolute;
    transform: translateX(-50%);
    left: 50%;
    width: 100%;
}

.tile-button-container {
    position: absolute;
    right: 30px;
    bottom: 35px;
}

.tile-button {
    display: inline-block;
    background-color: transparent;
    color: #fff;
    opacity: 1;

    :host(.is-opened) & {
        opacity: 0;
    }

    ux-icon {
        transition: all 300ms ease-in-out;
        font-size: 25px;
    }
}

.button-area {
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: transparent;
    border: 0;
    cursor: pointer;
    z-index: 1;
    border-radius: 0;
    padding: 0;
    appearance: none;
    transition: all 300ms ease-in-out;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
            179.77deg,
            #03496c 0.19%,
            rgba(3, 73, 108, 0.4) 99.79%
        );
        transition: all 300ms ease-in-out;
        pointer-events: none;
    }

    :host(.is-mobile) &,
    :host(.is-opened) &,
    &:hover {
        &::before {
            background: linear-gradient(
                179.77deg,
                #03496c 0.19%,
                rgba(3, 73, 108, 0) 53.34%
            );
        }
    }

    @media (prefers-reduced-motion: reduce) {
        &::before {
            background: linear-gradient(
                179.77deg,
                #03496c 0.19%,
                rgba(3, 73, 108, 0.4) 99.79%
            ) !important;
        }
    }

    &:hover .tile-button ux-icon {
        transform: rotate(90deg);
    }

    :host(.is-opened) & {
        cursor: default;
    }
}

.button-area-content {
    width: 100%;
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: left;
}

video {
    display: inline-block;
    width: 100%;
}

::slotted([slot="tile-title"]) {
    @include font(light);
    opacity: 1;
    transition: opacity 300ms ease-in-out;
    position: absolute;
    top: 30px;
    left: 30px;
    width: calc(100% - 60px);
    font-size: 16px !important;
    line-height: 1.2;
    color: #fff;
    margin: 0;

    @media (min-width: 1024px) {
        font-size: 20px !important;
    }

    @media (min-width: 1440px) {
        font-size: 23px !important;
    }
}

ux-modal {
    --ux-modal-max-width: 1900px;
}

.ux-modal__outer {
    @media (width >= 1024px) {
        width: 90%;
    }
}

.modal-media {
    background: #000;
    background-size: cover;
    background-position: center;
    position: relative;

    ux-video {
        width: 100%;
        height: 100%;
    }

    video {
        object-fit: contain;
        width: 100%;
        height: 100%;
    }

    &--desktop {
        width: 50%;
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        display: none;

        @media (min-width: 1024px) {
            display: block;
        }
    }

    &--mobile {
        display: block;
        height: 280px;
        margin: 0 -30px 30px;

        @media (min-width: 1024px) {
            display: none;
        }
    }
}

.modal-section-headline {
    @include nb-heading(6, true);
    margin: 0 0 15px;
}

.modal-challenge-container {
    margin: 30px 0;
    padding-bottom: 10px;
    border-bottom: solid 1px $color-black-4;
}

.modal-solution-container {
    margin: 30px 0;
    padding-left: 20px;
    border-left: solid 8px $color-green;
}

ux-modal-footer,
ux-modal-content {
    @media (min-width: 1024px) {
        margin-left: 50% !important;
        width: 50% !important;
    }
}

ux-modal-footer {
    @media (min-width: 1024px) {
        display: none !important;
    }
}

.link-button {
    &--desktop {
        display: none;

        @media (min-width: 1024px) {
            display: inline-block;
        }
    }

    &--mobile {
        @media (min-width: 1024px) {
            display: none;
        }
    }
}

::slotted([slot="modal-challenge"]),
::slotted([slot="modal-solution"]) {
    @include font(light);
}
